module.exports = __webpack_public_path__ + "img/check-list-icon.5b12d66c.svg";